import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { withRouter } from "react-router";

const RespuestaLarga = (props) => {
  const [opcionValue, setOpcionValue] = useState(
    props.valorOpcion ? props.valorOpcion.valor : null
  );

  const addValue = (value) => {
    let _opciones = props.opciones;
    setTimeout(() => {
      _opciones[props.index].valor = value;
      props.setOpciones(_opciones);
    }, 2000);
  };

  return (
    <Form.Group>
      <Row>
        <Col
          className="mb-3 d-flex flex-wrap justify-content-center align-items-center"
          sm="12"
          md="12"
          lg="12"
          xl="12"
        >
          <Form.Control
            id={`pregunta ${props.indexPregunta}${props.index}`}
            name="pregunta"
            required
            as="textArea"
            readOnly
            pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
            placeholder="Texto de respuesta larga"
          ></Form.Control>
        </Col>
        <Col
          xs="6"
          sm="6"
          md="2"
          lg="2"
          xl="2"
          className="mb-3 d-flex flex-wrap justify-content-center align-items-center"
        >
          <Form.Control
            id={`Valor ${props.indexPregunta}${props.index}`}
            name="Valor"
            className="rounded-pill"
            required
            type="number"
            min="0.00"
            // defaultValue={props.valorOpcion ? props.valorOpcion.valor : null}
            value={opcionValue}
            onChange={(e) => {
              // e.preventDefault();
              // setTimeout(() => {
              setOpcionValue(e.currentTarget.value);
              addValue(e.currentTarget.value);
              // }, 1000);
            }}
            // onChange={onSubmitValue}
            pattern="/^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/"
            placeholder="Valor"
          ></Form.Control>
        </Col>
      </Row>
    </Form.Group>
  );
};

export default withRouter(RespuestaLarga);
